const config = require("../config")

module.exports = {
    // 今日巡园重点
    todayPatrolFocus: {
        url: config.base_dev_url + "container_phenology_interaction/todayFocus_v2",
        type: "get",
    },
    // 待执行农事
    pendingFarmWork: {
        url: config.base_dev_url + "container_farm_work_group/pendingFarmWork",
        type: "get",
    },
    // 报告
    reproductiveReport: {
        url: config.base_dev_url + "container/reproductiveReport/listLatestByFarmRegion",
        type: "get",
    },
    // 添加执行图片并完成任务
    addExecuteImgAndComplete: {
        url: config.base_dev_url + "v2/z_farm_work_record/addExecuteImgAndComplete",
        type: "post",
    }
}